export const SITE_URL = "https://quranchatbuddy.com";
export const SITE_NAME = "Quran Chat Buddy";
export const DEFAULT_OG_IMAGE = `${SITE_URL}/images/og-cover.png`;
export const DEFAULT_DESCRIPTION =
    "Quran Chat Buddy is an AI-powered Islamic companion for Muslims — learn the Holy Quran & tafsir, track Salah prayer times, find Qibla, read daily ayat, and grow your deen anytime.";

export const SEO_KEYWORDS =
    "Quran, Holy Quran, Quran PDF, Quran app, Islam, Muslim app, prayer times, Salah, Namaz, Qibla, Surah Yaseen, Surah Yasin, AI Islamic chat, tafsir, dua, Ramadan, deen, how to pray, five pillars of Islam, Prophet Muhammad, Allah, Tawhid, Islamic learning";

export const IOS_APP_URL =
    "https://apps.apple.com/us/app/quran-chat-buddy-prayer-time/id6752615770";
export const ANDROID_APP_URL =
    "https://play.google.com/store/apps/details?id=com.quranchatbuddy.meccatime";
